import * as React from "react";
import { forwardRef } from "react";
const SvgCheckboxDefault = ({
  title,
  titleId,
  ...props
}, ref) => <svg width={15} height={15} viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<rect x={807.5} y={496.5} width={14} height={14} rx={3} transform="translate(-807 -496)" fill="#000" stroke="#5ACCE6" fillRule="evenodd" /></svg>;
const ForwardRef = forwardRef(SvgCheckboxDefault);
export { ForwardRef as ReactComponent };